export default "__VITE_ASSET__BfE08MVR__"